import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { TecAssuredStore } from "../../../../../../stores/TecAssuredStore";
import {
	getDocument,
	finalizeAgreement,
} from "../../../../../../api/TecAssuredAPI";
import { displayPdf } from "../../../../../../api/FormsAPI";
import { useFromUser } from "../../../../../../stores/LocalStorageHelper";
import useCurrentDealStore from "../../../../../../stores/DealStore";
import shallow from "zustand/shallow";
import { saveDeal } from "../../../../../../api/DealAPI";
import useSetDeal from "../../../../hooks/useSetDeal";
import useBuildDeal from "../../../../hooks/useBuildDeal";

const TecAssuredFinalizeTab = () => {
	const { agreementReqBody, setAgreementReqBody } = TecAssuredStore();
	const [finalized, setFinalized] = useState(false);
	const [loading, setLoading] = useState({
		preview: false,
		finalize: false,
		finalDoc: false,
	});
	const { editTecAssuredGapDocId } = useCurrentDealStore(
		(state) => state,
		shallow
	);
	const { warrantyList, editWarrantyList } = useCurrentDealStore(
		(state) => ({
			warrantyList: state.warranty,
			editWarrantyList: state.editWarranty,
		}),
		shallow
	);

	const setDeal = useSetDeal();
	const getDeal = useBuildDeal();
	const locationID = useFromUser("locationID");

	const handlePreview = async () => {
		setLoading((prev) => ({ ...prev, preview: true }));
		try {
			const { Products } = agreementReqBody?.Agreement || {};
			if (Products?.DocumentID) {
				const res = await getDocument({
					documentId: Products.DocumentID,
					locationId: locationID,
				});
				displayPdf(res);
			}
		} finally {
			setLoading((prev) => ({ ...prev, preview: false }));
		}
	};

	const handleFinalize = async () => {
		setLoading((prev) => ({ ...prev, finalize: true }));
		try {
			const res = await finalizeAgreement(agreementReqBody);
			if (res?.data?.Products?.DocumentID) {
				setAgreementReqBody({
					locationId: locationID,
					Agreement: res.data,
				});

				// this is gap
				if (Number(res?.data?.Products.ProductTypeID) === 4) {
					editTecAssuredGapDocId(res?.data?.Products?.DocumentID);
				} else {
					// find warranty and set docId
					// Find the warranty with matching ProductID
					const warrantyIndex = warrantyList.findIndex(
						(warranty) => warranty.ProductID === currentProductID
					);

					if (warrantyIndex !== -1) {
						// Create a copy of the warranty list
						const updatedWarrantyList = [...warrantyList];
						// Update the amount for the matching warranty
						updatedWarrantyList[warrantyIndex] = {
							...updatedWarrantyList[warrantyIndex],
							tecAssuredDocId: res?.data?.Products?.DocumentID,
						};
						// Update the warranty list in the store
						editWarrantyList(updatedWarrantyList);
					}
				}

				const saveData = () => {
					const deal = getDeal();
					saveDeal(deal).then(
						(response) => {
							setDeal(response.data.content);
							setFinalized(true);
						},
						(err) => {
							console.error(err);
							setFinalized(true);
						}
					);
				};
				saveData();
			}
		} finally {
			setLoading((prev) => ({ ...prev, finalize: false }));
		}
	};

	const handleGetFinalDoc = async () => {
		setLoading((prev) => ({ ...prev, finalDoc: true }));
		try {
			const { Products } = agreementReqBody?.Agreement || {};
			if (Products?.DocumentID) {
				const res = await getDocument({
					documentId: Products.DocumentID,
					locationId: locationID,
				});
				displayPdf(res);
			}
		} finally {
			setLoading((prev) => ({ ...prev, finalDoc: false }));
		}
	};

	return (
		<Row className="mt-4" form>
			<Col xs="12" md="4" className="mb-2">
				<Button
					color="secondary"
					block
					onClick={handlePreview}
					disabled={finalized || loading.preview}
				>
					{loading.preview ? "Previewing..." : "Preview"}
				</Button>
			</Col>

			<Col xs="12" md="4" className="mb-2">
				<Button
					color="primary"
					block
					onClick={handleFinalize}
					disabled={finalized || loading.finalize}
				>
					{loading.finalize ? "Finalizing..." : "Finalize"}
				</Button>
			</Col>

			<Col xs="12" md="4" className="mb-2">
				<Button
					color="success"
					block
					onClick={handleGetFinalDoc}
					disabled={!finalized || loading.finalDoc}
				>
					{loading.finalDoc ? "Loading..." : "Get Final Document"}
				</Button>
			</Col>
		</Row>
	);
};

export default TecAssuredFinalizeTab;
